var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('kriminal')],1),_c('div',{staticClass:"col-md-4"},[_c('tangkap-dpo')],1),_c('div',{staticClass:"col-md-4"},[_c('tangkap-dpk')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }